// extracted by mini-css-extract-plugin
module.exports = {"links":"PublisherLinks-module--links--1rBA2","linksExternal":"PublisherLinks-module--linksExternal--3jORC index-module--linksExternal--1Go7u"};